import { render, staticRenderFns } from "./changeRFCNumStatus.vue?vue&type=template&id=20465ee8&scoped=true&"
import script from "./changeRFCNumStatus.vue?vue&type=script&lang=js&"
export * from "./changeRFCNumStatus.vue?vue&type=script&lang=js&"
import style0 from "./changeRFCNumStatus.vue?vue&type=style&index=0&id=20465ee8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20465ee8",
  null
  
)

export default component.exports